module.exports = __webpack_public_path__ + "img/dd581c4.png";